import React from "react";
import ClearingActions from "./components/ClearingActions";

export default function ClearingPage() {
  return (
    <div className="layout-main">
      <div className="surface-section">
        <div className="grid">
          <div className="col-12">
            <ClearingActions />
          </div>
        </div>
      </div>
    </div>
  );
}
